import { Editor, Range } from 'slate';

/**
 * 检测 Slate 编辑器当前光标位置的命令状态（@ 或 /）
 * @param {Editor} editor - Slate 编辑器实例
 * @param {string[]} triggers - 触发字符数组，如 ['@', '/']
 * @returns {{ trigger: string, query: string } | null}
 */
export function getSlateCommandState(editor, triggers = ['@', '/']) {
  const { selection } = editor;
  if (!selection || !Range.isCollapsed(selection)) return null;

  const cursorPoint = Range.start(selection);
  const beforeRange = Editor.range(editor, Editor.start(editor, []), cursorPoint);
  const beforeText = Editor.string(editor, beforeRange);

  // 从后往前找最近的触发字符
  let lastTriggerIndex = -1;
  let matchedTrigger = null;

  for (const trigger of triggers) {
    const idx = beforeText.lastIndexOf(trigger);
    if (idx > lastTriggerIndex) {
      lastTriggerIndex = idx;
      matchedTrigger = trigger;
    }
  }

  if (lastTriggerIndex === -1) return null;

  // 检查触发字符后是否有空格（有空格说明已经结束了命令）
  const afterTrigger = beforeText.slice(lastTriggerIndex + 1);
  if (afterTrigger.includes(' ') || afterTrigger.includes('\n')) return null;

  return {
    trigger: matchedTrigger,
    query: afterTrigger
  };
}

/**
 * 获取 Slate 编辑器当前光标位置在纯文本中的偏移量
 * @param {Editor} editor - Slate 编辑器实例
 * @returns {number}
 */
export function getSlateTextOffset(editor) {
  const { selection } = editor;
  if (!selection) return 0;

  const cursorPoint = Range.start(selection);
  const beforeRange = Editor.range(editor, Editor.start(editor, []), cursorPoint);
  return Editor.string(editor, beforeRange).length;
}
